import { useState } from 'react';
export var useModalState = function () {
    var _a = useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var openModal = function () { return setModalOpen(true); };
    var closeModal = function () { return setModalOpen(false); };
    return { modalOpen: modalOpen, openModal: openModal, closeModal: closeModal };
};
